import api from "@/services/api"
import {
  normalizeAccessAdmin,
  normalizeAccessAdminsPayload,
  normalizeAccessAuditItems,
  normalizeAccessCapabilityGroups,
  normalizeAccessRole,
  normalizeAccessRolesList,
} from "@/api/normalizers/access.normalizer"
import { projectAccessPermissionHierarchy } from "@/api/normalizers/accessPermissionHierarchy.normalizer"

export { projectAccessPermissionHierarchy }

/**
 * Access Client
 *
 * Backend contract wrapper for RBAC role/capability/admin assignment endpoints.
 */
export function createAccessClient() {
  return {
    listRoles: async () => {
      const response = await api.get("access/roles")
      return normalizeAccessRolesList(response.data?.roles)
    },
    getRole: async (roleId) => {
      const response = await api.get(`access/roles/${roleId}`)
      return normalizeAccessRole(response.data)
    },
    saveRole: async (payload) => {
      const roleId = payload?.id || null
      const endpoint = roleId ? `access/roles/${roleId}` : "access/roles"
      const response = await api.post(endpoint, payload, {
        headers: { "Content-Type": "application/json" },
      })
      return normalizeAccessRole(response.data)
    },
    listCapabilities: async () => {
      const response = await api.get("access/capabilities")
      const hierarchy = projectAccessPermissionHierarchy(response.data)
      const groups = normalizeAccessCapabilityGroups(response.data)
      Object.defineProperty(groups, "permissionHierarchy", {
        configurable: false,
        enumerable: false,
        value: hierarchy,
        writable: false,
      })
      return groups
    },
    listAdmins: async () => {
      const response = await api.get("access/admins")
      return normalizeAccessAdminsPayload(response.data)
    },
    assignAdminRole: async (adminId, roleId) => {
      const response = await api.post(
        `access/admins/${adminId}/role`,
        { role_id: roleId },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      return normalizeAccessAdmin(response.data)
    },
    listAudit: async (limit = 100) => {
      const response = await api.get("access/audit", { params: { limit } })
      return normalizeAccessAuditItems(response.data?.items)
    },
  }
}

export const accessClient = createAccessClient()
